import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Styles from "../../../assets/styles/componentStyles/globalSearch.module.scss"
import { SxProps, Theme } from '@mui/material';

interface GlobalSearchProps {
    placeholder?: string,
    className?: string,
    size: 'small' | 'medium'
    value?: string,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    fullWidth?: boolean,
    style?: React.CSSProperties,
    sx?: SxProps<Theme>
}

const GlobalSearch = (props: GlobalSearchProps) => {
    return (
        <div>
            <TextField
                id="outlined-search"
                variant='outlined'
                type="search"
                autoComplete="off"
                placeholder={props.placeholder}
                className={`${props.className} ${Styles.globalSearch}`}
                size={props.size}
                style={props.style}
                sx={props.sx}
                value={props.value}
                onChange={props.onChange}
                fullWidth={props.fullWidth}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position='start'>
                            <SearchIcon style={{ color: "#7A7A7A" }} />
                        </InputAdornment>
                    ),
                }}
            />
        </div>
    );
};

export default GlobalSearch;
